export default __webpack_public_path__ + "static/media/bg.ad98268b.mp4";